import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchVehicle = createAsyncThunk(
    'vehicle/list', 
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/vehicle/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching vehicle:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const fetchVehicleModel = createAsyncThunk(
    'vehicle/list-model', 
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/vehicle/list-model`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching vehicle model:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const fetchVehicleVariant = createAsyncThunk(
    'vehicle/list-variant', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/vehicle/list-variant?mastercode=${item}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching vehicle variant:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const fetchVehicleType = createAsyncThunk(
    'vehicle/list-type', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/vehicle/list-type?variant=${item}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching vehicle type:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const fetchVehicleTransmission = createAsyncThunk(
    'vehicle/list-transmission', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/vehicle/list-transmission?variant=${item}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching vehicle transmission:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const vehiclePerCustomer = createAsyncThunk(
    'vehicle/per-customer', 
    async (items, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.post(`${API_URL}/vehicle/per-customer`, items, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching vehicle per customer:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

const vehicleSlice = createSlice({
    name: 'vehicle',
    initialState: {
        vehicle: [],
        vehicle_model: [],
        vehicle_variant: [],
        vehicle_type: [],
        vehicle_per_customer: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchVehicle.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(fetchVehicle.fulfilled, (state, action) => {
            state.isLoading = false;
            state.vehicle = action.payload;
        })
        .addCase(fetchVehicle.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(fetchVehicleModel.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(fetchVehicleModel.fulfilled, (state, action) => {
            state.isLoading = false;
            state.vehicle_model = action.payload;
        })
        .addCase(fetchVehicleModel.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(fetchVehicleVariant.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(fetchVehicleVariant.fulfilled, (state, action) => {
            state.isLoading = false;
            state.vehicle_variant = action.payload;
        })
        .addCase(fetchVehicleVariant.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(fetchVehicleType.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(fetchVehicleType.fulfilled, (state, action) => {
            state.isLoading = false;
            state.vehicle_type = action.payload;
        })
        .addCase(fetchVehicleType.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(vehiclePerCustomer.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(vehiclePerCustomer.fulfilled, (state, action) => {
            state.isLoading = false;
            state.vehicle_per_customer = action.payload;
        })
        .addCase(vehiclePerCustomer.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
    },
});

export default vehicleSlice.reducer;